import React from 'react';
import { Grid, Menu, Button, MenuItem } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

function ZoneActionMenu({
  zoneId,
  active,
  onActivityToggle = () => {},
  onEdit = () => {},
  onDelete = () => {},
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const EDIT_ZONE = 'Edit';
  const ACTIVATE_ZONE = 'Activate';
  const DEACTIVATE_ZONE = 'Deactivate';
  const DELETE_ZONE = 'Delete';

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Grid container justifyContent="center">
      <Button onClick={handleClick}>
        <MoreHoriz />
      </Button>
      <Menu
        id="zone-action-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onEdit(zoneId);
            setAnchorEl(null);
          }}
          name={EDIT_ZONE}
          value={EDIT_ZONE}
        >
          {EDIT_ZONE}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onActivityToggle(zoneId);
            setAnchorEl(null);
          }}
          name={active ? DEACTIVATE_ZONE : ACTIVATE_ZONE}
          value={active ? DEACTIVATE_ZONE : ACTIVATE_ZONE}
        >
          {active ? DEACTIVATE_ZONE : ACTIVATE_ZONE}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onDelete(zoneId);
            setAnchorEl(null);
          }}
          name={DELETE_ZONE}
          value={DELETE_ZONE}
        >
          {DELETE_ZONE}
        </MenuItem>
      </Menu>
    </Grid>
  );
}

export default ZoneActionMenu;
